import { AskScope } from '../api';
import { withChatDirectives } from './withAskDirectives';

/** The gateway validates `prompt` at 1-4000 characters; over is a rejected request. */
export const ASK_PROMPT_MAX_CHARS = 4000;

/** Rounded down to a whole hundred, so the composer shows a limit rather than a remainder. */
const LIMIT_GRANULARITY = 100;

/**
 * How much of the prompt budget is left for the user's own words.
 *
 * The directives ride along on the prompt itself (the gateway takes no system field), so they
 * spend the same 4000 characters the question does. Derived rather than hard-coded because the
 * language directive changes with the UI language and the set itself keeps shrinking as the
 * gateway's system prompt takes rules over: a fixed number would drift into rejected requests
 * the next time either changes.
 *
 * Exact, not an estimate: `withChatDirectives` appends with a join, so the cost of the
 * directives is the length of `withChatDirectives('', scope)`. The panel is the only
 * surface with a composer, so the chat set is the one that has to be paid for here.
 *
 * Priced as though the question were dictated, whether or not it was. The dictation tag is only
 * added to turns that had a dictation in them, so charging every turn for it gives up ~33 of ~2900
 * characters — against the alternative of a limit that is right until someone uses the microphone
 * and then lets a question through that the gateway rejects.
 */
export function askPromptLimit(scope: AskScope | undefined): number {
  const directiveChars = withChatDirectives('', scope ?? { type: 'org' }, {
    dictatedText: 'priced as dictated',
  }).length;
  const room = ASK_PROMPT_MAX_CHARS - directiveChars;
  return Math.floor(room / LIMIT_GRANULARITY) * LIMIT_GRANULARITY;
}
